<template>
  <section class="py-4">
    <v-form>
      <v-row class="ms-1 me-1 mt-1" justify="center">
        <v-col cols="12" md="4" lg="4" xs="12">
          <label class="required labelFontsize my-0">
            Bussiness Name/Company Name
          </label>
          <v-text-field
            class="rounded"
            dense
            outlined
            placeholder="Company Name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <label class="labelFontsize my-0">Company Registration Number </label>
          <v-text-field
            dense
            outlined
            placeholder="Company Registration Number"
            class="rounded"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <label class="labelFontsize  my-0">
            Nature Of Bussiness
          </label>
          <v-autocomplete
            dense
            outlined
            placeholder=" Nature Of Bussiness"
            class="rounded"
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-row class="ms-1 me-1 mt-1">
        <v-col cols="12" md="4">
          <label class="labelFontsize required my-0">Address</label>
          <v-text-field
            class="rounded"
            dense
            outlined
            placeholder="Address"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <label class="labelFontsize required my-0"> Beneficiary Country</label>
          <v-autocomplete
            class="rounded"
            dense
            outlined
            placeholder="Beneficiary Country"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <label class="labelFontsize required my-0"> Province</label>
          <v-autocomplete
            class="rounded"
            dense
            outlined
            placeholder="Province"
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-row class="ms-1 me-1 mt-1" >
        <v-col cols="12" md="4">
          <label class="labelFontsize required my-0">City</label>
          <v-text-field
            dense
            outlined
            placeholder="City"
            class="rounded"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <label class="labelFontsize my-0">Postal Code </label>
          <v-text-field
            dense
            outlined
            placeholder="Postal Code "
            class="rounded"
          ></v-text-field>
        </v-col>
        <!-- <v-col cols="12" md="4">
          <label class="labelFontsize required my-0"> Relationship </label>
          <v-autocomplete
            dense
            class="rounded"
            outlined
            placeholder="Relationship "
          ></v-autocomplete>
        </v-col> -->
      </v-row>
      <v-row class="ms-1 me-1 mt-1" justify="center">
        <v-col cols="12" md="4" >
          <label class="labelFontsize required my-0"> First Name </label>
          <v-text-field
            dense
            outlined
            placeholder="First Name"
            class="rounded"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="4" >
          <label class="labelFontsize  my-0"> Last Name </label>
          <v-text-field
            dense
            outlined
            placeholder="Last Name"
            class="rounded"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" >
          <label class="labelFontsize  my-0"> Date Of Birth </label>
          <v-text-field
            dense
            class="rounded"
            outlined
            type="date"
            placeholder="Date Of Birth  "
          ></v-text-field>
        </v-col>
        
      </v-row>
      <v-row class="ms-1 me-1 mt-1" >
        <v-col cols="12" md="4" >
          <label class="labelFontsize  my-0"> Designation </label>
          <v-text-field
            dense
            outlined
            placeholder="Designation"
            class="rounded"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <label class="my-0 required">Contact Number</label>
          <vue-phone-number-input
            default-country-code="MY"
            v-model="userData.phone"
            @update="onChangeNumber($event)"
           
          />

          <!-- {{userData.results}} 
          <div v-if="isSubmitted" class="invalid-feedback-name">
            {{ $t("phonenumber_field_is_required")}}
          </div>  -->
        </v-col>
        <v-col cols="12" md="4" >
          <label class="labelFontsize my-0"> E-mail </label>
          <v-text-field
            dense
            outlined
            placeholder="E-mail"
            class="rounded"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ms-1 me-1 mt-1" >
       

        <v-col cols="12" md="4">
          <label class="labelFontsize required my-0"> Bank Name </label>
          <v-autocomplete
            dense
            outlined
            placeholder="Bank Name "
            class="rounded"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <label class="labelFontsize  my-0">
            Branch Code
          </label>
          <v-text-field
            dense
            class="rounded"
            outlined
            placeholder="Branch Code "
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <label class="labelFontsize required my-0">
           Account Number
          </label>
          <v-text-field
            dense
            class="rounded"
            outlined
            placeholder="Account Number "
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="ms-1 me-1 mt-1">
        
      </v-row>
      <v-col cols="12" md="12">
        <v-row class="d-flex justify-end">
          <v-btn depressed 
            color="primary"
            
            class="ma-2 mb-10 text-capitalize"
            width="120px"
          >
            <!-- <v-icon dark> mdi-send-circle-outline </v-icon> -->
            <v-icon small class="me-2">mdi-content-save-check-outline</v-icon>Submit
          </v-btn>
          <v-btn depressed 
            class="ma-2 text-capitalize"
            width="120px"
            color="primary"
            outlined
          >
            <!-- <v-icon dark> mdi-file-document-remove-outline </v-icon> -->
            <v-icon small class="me-2">mdi-close-circle-outline</v-icon> Cancel
          </v-btn>
        </v-row>
      </v-col>
    </v-form>
  </section>
</template>

<script>

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
export default {
  data: () => ({

    color: "#FF0000",
  }),

  components: {
    VuePhoneNumberInput,
  },
  props: {
    userData: {
      type: Object,
      default() {
        return {};
      },
    },
    Data: {
      type: Object,
      default() {
        return {};
      },
    },
    Mobile: {
      type: Object,
      default() {
        return {};
      },
    },
    onCheckFlag: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
